module.exports = __webpack_public_path__ + "static/media/checkmark.366a6366.svg";